import React, { PropTypes } from 'react';
import * as B from 'react-bootstrap';
import './styles/ask.scss';
import { messagePropTypes, surveyAdditionalDataPropTypes } from '../propTypes';

const chatInteractiveSurveyAsk = ({ className, message, onAccept, onDecline, willAnswer, nextAdditionalData, willAnswerLabel, wontAnswerLabel}) => (
  <div className={'interactive-survey-message-ask ' + className}>
    <p className="interactive-survey-message-ask-content">{message.content}</p>
    {
      willAnswer === undefined ? (
        <p className="interactive-survey-message-ask-buttons text-center">
          <B.Button bsStyle="success" onClick={onAccept.bind(null, nextAdditionalData)}>{willAnswerLabel}</B.Button>
          <B.Button bsStyle="danger" onClick={onDecline}>{wontAnswerLabel}</B.Button>
        </p>
      ) : undefined
    }
  </div>
);

chatInteractiveSurveyAsk.propTypes = {
  willAnswerLabel: PropTypes.string.isRequired,
  wontAnswerLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  message: messagePropTypes.isRequired,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  willAnswer: PropTypes.bool,
  nextAdditionalData: surveyAdditionalDataPropTypes,
};

export default chatInteractiveSurveyAsk;



// WEBPACK FOOTER //
// ./components/chat/interactiveSurvey/Ask.js